import * as core from './core'
import { CliClient } from '../rpc'
import { ec as EC } from 'elliptic'

class AnonymousAccount {
  constructor (str = null) {
    if (!str) {
      this.spendingKey = core.generatePrivateKey()
    } else if (typeof str === 'object') {
      this.spendingKey = str.spendingKey
      this.viewingKey = str.viewingKey
      this.receivingKey = str.receivingKey
      this.address = str.address
    } else {
      throw new ReferenceError(`Invalid input: ${str}`)
    }
  }

  /** initialize viewingkey, receivingkey, address with spendingkey */
  init (net) {
    const cliClient = new CliClient(net)

    return cliClient.getOneTimePubkey()
      .then((res) => {
        if (res === '') throw new Error('Initialization failed!')

        var serverPubkey = res
        var keypair = new EC('p256').genKeyPair()
        var cipher = core.processEncrypt(this.spendingKey, keypair.getPrivate('hex'), serverPubkey)

        return cliClient.createAnonymousWallet(cipher)
          .then((res) => {
            try {
              if (res === undefined) throw new Error('Initialization failed!')

              var ret = core.processDecrypt(res, keypair.getPrivate('hex'))

              this.viewingKey = ret.viewingKey
              this.receivingKey = ret.receivingkey
              this.address = ret.address
              this.spendingKey = ret.spendingkey
            } catch (err) {
              throw new Error('Initialization failed!')
            }

            return true
          })
      })
  }

  /** get anonymous wallet balance */
  getBalance (net) {
    if (this.address === undefined || this.spendingKey === undefined) {
      throw new Error('Please initialize the wallet.')
    }

    const cliClient = new CliClient(net)

    return cliClient.getOneTimePubkey()
      .then((res) => {
        if (res === '') throw new Error('Initialization failed!')

        var request = {
          address: this.address,
          privatekey: this.spendingKey
        }

        var serverPubkey = res
        var keypair = new EC('p256').genKeyPair()
        var cipher = core.processEncrypt(JSON.stringify(request), keypair.getPrivate('hex'), serverPubkey)

        return cliClient.getPrivateBalance(cipher)
          .then((res) => {
            try {
              if (res === undefined) throw new Error('Getting balance failed!')

              var ret = core.processDecrypt(res, keypair.getPrivate('hex'))

              return ret
            } catch (err) {
              throw new Error('Getting balance failed!')
            }
          })
      })
  }

  /** get anonymous wallet balance */
  getTransactionHistory (net) {
    if (this.address === undefined || this.spendingKey === undefined) {
      throw new Error('Please initialize the wallet.')
    }

    const cliClient = new CliClient(net)

    return cliClient.getOneTimePubkey()
      .then((res) => {
        if (res === '') throw new Error('Initialization failed!')

        var request = {
          address: this.address,
          privatekey: this.spendingKey
        }

        var serverPubkey = res
        var keypair = new EC('p256').genKeyPair()
        var cipher = core.processEncrypt(JSON.stringify(request), keypair.getPrivate('hex'), serverPubkey)

        return cliClient.getPrivateTransactionHistory(cipher)
          .then((res) => {
            try {
              if (res === undefined) throw new Error('Getting Transaction History failed!')

              var ret = core.processDecrypt(res, keypair.getPrivate('hex'))

              return ret
            } catch (err) {
              throw new Error('Getting Transaction History failed!')
            }
          })
      })
  }

  /** send private tx */
  sendPrivateTx (net, toAddress, assetId, amount) {
    if (this.address === undefined || this.spendingKey === undefined) {
      throw new Error('Please initialize the wallet.')
    }

    const cliClient = new CliClient(net)

    return cliClient.getOneTimePubkey()
      .then((res) => {
        if (res === '') throw new Error('Initialization failed!')

        var request = {
          address: this.address,
          to_address: toAddress,
          assetId: assetId,
          amount: amount,
          privatekey: this.spendingKey
        }

        var serverPubkey = res
        var keypair = new EC('p256').genKeyPair()
        var cipher = core.processEncrypt(JSON.stringify(request), keypair.getPrivate('hex'), serverPubkey)

        return cliClient.sendPrivateTx(cipher)
          .then((res) => {
            try {
              if (res === undefined) throw new Error('Sending private tx failed!')

              var ret = core.processDecrypt(res, keypair.getPrivate('hex'))

              return ret
            } catch (err) {
              throw new Error('Sending private tx failed!')
            }
          })
      })
  }

  /** rebuild wallet */
  rebuildWallet (net) {
    if (this.address === undefined || this.spendingKey === undefined) {
      throw new Error('Please initialize the wallet.')
    }

    const cliClient = new CliClient(net)

    return cliClient.getOneTimePubkey()
      .then((res) => {
        if (res === '') throw new Error('Initialization failed!')

        var request = {
          address: this.address,
          privatekey: this.spendingKey
        }

        var serverPubkey = res
        var keypair = new EC('p256').genKeyPair()
        var cipher = core.processEncrypt(JSON.stringify(request), keypair.getPrivate('hex'), serverPubkey)

        return cliClient.rebuildWallet(cipher)
          .then((res) => {
            try {
              if (res === undefined) throw new Error('Rebuilding wallet failed!')

              var ret = core.processDecrypt(res, keypair.getPrivate('hex'))

              return ret
            } catch (err) {
              throw new Error('Rebuilding wallet failed!')
            }
          })
      })
  }
}

export default AnonymousAccount
